import React, { useEffect, useState } from 'react'
import { AlertError } from '../../components'
import { Form, Sidebar } from './components'
import singleService from '../../features/resource/service'
import resourceService from '../../features/resources/service'
import { useDispatch, useSelector } from 'react-redux'
import { fetchResources } from '../../features/resources/slice'
import { useHistory } from 'react-router-dom'
import { reset, updateImage } from '../../features/resource-form/slice'
import { blobToFile } from '../../utils'
import { toast } from 'react-toastify'

const DashboardResourceForm = ({ isEdit }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const form = useSelector(state => state.resourceForm.data)
  const [requesting, setRequesting] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [showForm, setShowForm] = useState(true)

  useEffect(() => {
    if (!isEdit) {
      setShowForm(false)
      dispatch(reset())
      setTimeout(() => setShowForm(true), 100)
    }
  }, [dispatch, isEdit])

  const isValid = () => {
    let result = true
    let msg = ''

    const {
      title_en,
      title_id,
      about_en,
      about_id
    } = form

    if(!title_en){
      msg += '"Title - English" is required. '
      result = false
    }

    if(!title_id){
      msg += '"Title - Indonesia" is required. '
      result = false
    }

    if(
      (!about_en && !about_id)
      || (about_en === 'N/A' && about_id === 'N/A')
    ){
      msg += '"About" is required.'
      result = false
    }

    if(msg !== ''){
      setErrorMessage(msg)
    }

    return result
  }

  async function checkImage(res) {
    const id = res.resourceId
    const isNeedToUpdateImage = id && form.new_image && form.new_image.blob.slice(0, 4) === 'blob'
    const isNeedToUpdateThumbnail = id && form.new_thumbnail && form.new_thumbnail.blob.slice(0, 4) === 'blob'

    const promises = []

    if(isNeedToUpdateImage){
      const data = form.new_image
      console.log('update image props:', id, data)
      const promise1 = dispatch(updateImage({id, data, key: 'imgMainImage'}))
      promises.push(promise1)
    }
    if(isNeedToUpdateThumbnail){
      const data = form.new_thumbnail
      console.log('update image props:', id, data)
      const promise2 = dispatch(updateImage({id, data, key: 'imgThumbnail'}))
      promises.push(promise2)
    }

    return Promise.all(promises)
  }

  async function updateFile(resourceId, blobObject){
    return new Promise((resolve, reject) => {
      console.log('resource update file')
      singleService.getData(resourceId)
      .then((res) => {
        // Blob's source: check form-file.js line 59
        const blob = blobObject

        if(blob){
          const { url, name, type } = blob

          if(url && name && type){
            blobToFile(url, name, type).then(file => {
              /** @warning: response from backend is not consistent */
              // const resource = res[0]
              const resource = res.results

              if(resource){
                const { resourcesFiles } = resource
                if(resourcesFiles && resourcesFiles !== null){
                  const pkFileId = resourcesFiles.pkFileId

                  const formData = new FormData()
                  formData.append('binFile', file)

                  resourceService.updateResourceFile(pkFileId, formData)
                    .then(() => resolve())
                    .catch(err => reject(err))
                } else {
                  resolve()
                }
              } else {
                resolve()
              }
            }).catch(err => {
              reject(err)
            })
          }
        } else {
          resolve()
        }
      })
      .catch(() => reject())
    })
  }

  const handleEdit = (e) => {
    let finalForm = {...form}

    // Handle 'draft' status
    if(e.submission){
      finalForm.submission = e.submission
    }

    // Edit Resource
    resourceService.updateResource({
      id: form.id,
      data: finalForm
    })
      .then(res => {
        checkImage({resourceId: form.id})
        .then(() => updateFile(form.id, form.file.blob))
        .finally(() => {
          handleFinish()
        })
      })
      .catch(err => {
        setErrorMessage(err)
        console.log(err)
        setRequesting(false)
      })

    function handleFinish(){
      setRequesting(false)
      toast.success('Successfully updated!')
      history.push('/dashboard/resources')
      dispatch(reset())
      dispatch(fetchResources())
    }
  }

  const handleCreate = (e) => {
    let finalForm = {...form}

    // Handle 'draft' status
    if(e.submission){
      finalForm.submission = e.submission
    }

    resourceService.createResource(finalForm)
      .then((res) => {
        checkImage(res)
        .then(() => updateFile(res.resourceId, form.file.blob))
        .finally(() => {
          handleFinish()
        })
      })
      .catch((err) => {
        setErrorMessage(err)
        setRequesting(false)
      })

    function handleFinish(){
      setRequesting(false)
      toast.success('Successfully created!')
      history.push('/dashboard/resources')
      dispatch(fetchResources())
    }
  }

  const handleSubmit = (e) => {
    if(e.preventDefault){
      e.preventDefault()
    }

    console.log(form)
    setErrorMessage(null)

    if(isValid()){
      setRequesting(true)
      if(isEdit){
        handleEdit(e)
      } else {
        handleCreate(e)
      }
    }
  }

  return (
    <>
      {
        errorMessage &&
        <div className="mb-8">
          <AlertError
            message={errorMessage}
            onClose={() => setErrorMessage(null)}
          />
        </div>
      }

      {
        showForm &&
        <form
          className="flex flex-wrap -mx-4"
          onSubmit={handleSubmit}
        >
          <div className="w-full lg:w-2/3 pl-4 pr-4 lg:pr-8">
            <Form isEdit={isEdit} />
          </div>
          <div className="w-full lg:w-1/3 px-4">
            <Sidebar
              isEdit={isEdit}
              requesting={requesting}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              handleSubmit={handleSubmit}
            />
          </div>
        </form>
      }
    </>
  )
}

export { DashboardResourceForm }
